import { readSocialPostPreviewCard, type SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';
import { awaitsDecision, type BucketableTask } from './agent-task-buckets';

type CardSource = Parameters<typeof readSocialPostPreviewCard>[0];

export function taskPostPreviewCard(task: BucketableTask & { display?: unknown }): SocialPostPreviewCardMetadata | null {
  const card = readSocialPostPreviewCard(task.display as CardSource);
  if (!card) return null;
  if (task.status === 'ACTION_NEEDED') return card;
  return awaitsDecision(task) && task.decisionPrompts?.some((prompt) => prompt.decisionId === card.decisionId) ? card : null;
}

export function postPreviewHoldsDecision(
  card: SocialPostPreviewCardMetadata | undefined,
  prompts: { decisionId?: string }[] | undefined,
  answeredDecisionIds: readonly string[],
): SocialPostPreviewCardMetadata | undefined {
  if (!card || answeredDecisionIds.includes(card.decisionId)) return undefined;
  return prompts?.some((prompt) => prompt.decisionId === card.decisionId) ? card : undefined;
}
